"use client";
import { PoolInfo } from "@/contracts/react/hooks";
import { ApiPoolAprResponse, ApiTotalsResponse } from "@/types/api";

import { Pool } from "../types";

interface Props {
  pool: Pool;
  poolsApr: Record<string, ApiPoolAprResponse> | undefined;
  poolsTotal: Record<string, ApiTotalsResponse> | undefined;
  poolInfo: PoolInfo | undefined;
  priceByToken: Record<`0x${string}`, number> | undefined;
}
export const getAdditionalPoolInfo = ({
  pool,
  poolsApr,
  poolsTotal,
  poolInfo,
  priceByToken,
}: Props) => {
  if (!poolsApr || !poolsTotal) return null;
  const address = pool.address;
  const poolAprInfo = poolsApr[address];
  const state = poolsTotal[address];
  const displayApr = pool.isBaseToken
    ? poolAprInfo?.lendCurrentBaseApr
    : poolAprInfo?.lendCurrentQuoteApr;
  const apr = (displayApr || 0) / 100;
  const totalCollateral =
    (pool.isBaseToken ? state?.baseCollateral : state?.quoteCollateral) || 0;
  const totalDebt =
    (pool.isBaseToken ? state?.baseDebt : state?.quoteDebt) || 0;
  const tokenAddress = pool.isBaseToken
    ? poolInfo?.quoteToken?.address
    : poolInfo?.baseToken?.address;
  const basePriceUsd = (tokenAddress && priceByToken?.[tokenAddress]) || 0;
  const totalCollateralUsd = totalCollateral * basePriceUsd;
  const totalDebtUsd = totalDebt * basePriceUsd;
  return { apr, totalDebtUsd, totalCollateralUsd, totalCollateral, totalDebt };
};
